<template>
  <el-form :model="form" :rules="rules" ref="form" @submit.prevent.native="onSubmit">
    <el-form-item label="Title" prop="title">
      <el-input v-model="form.title"></el-input>
    </el-form-item>
    <el-form-item label="Group" prop="group">
      <el-select v-model="form.group" placeholder="Select a group">
        <el-option v-for="(name, id) in groups" :key="id" :label="name" :value="id"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="Keywords in step">
      <el-input v-model="form.keywords"></el-input>
    </el-form-item>
    <el-form-item label="Description" prop="desc">
      <el-input v-model="form.desc" type="textarea" rows="5"></el-input>
    </el-form-item>
    <el-button native-type="submit" type="primary" :loading="loading">Save</el-button>
  </el-form>
</template>

<script>
export default {
  props: {
    category: Object,
  },

  data() {
    return {
      loading: false,
      form: {
        title: this.category.title,
        group: this.category.group,
        keywords: this.category.keywords.join(', ') || null,
        desc: this.category.desc,
      },
      groups: {
        'cookware': 'Cookware',
        'cutleries': 'Cutleries',
        'utensils': 'Kitchen Utensils',
        'knives': 'Knives',
        'scissors': 'Scissors',
      },
      rules: {
        'desc': [
          { required: true, message: 'Enter the category description.', trigger: 'blur' },
        ],
        'group': [
          { required: true, message: 'Select the main category.', trigger: 'blur' },
        ],
        'title': [
          { required: true, message: 'Enter the category title.', trigger: 'blur' },
        ],
      },
    }
  },

  methods: {
    async onSubmit() {
      this.$refs['form'].validate(async valid => {
        if (!valid) {
          return false
        }

        this.loading = true

        try {
          var { data } = await this.$http.put(`/categories/${ this.category.id }`, this.form)
        } catch(err) {
          this.$message.error(err.response.data.message)
          return false
        } finally {
          this.loading = false
        }

        this.$message.success(data.message)
      })
    },
  },
}
</script>
